




















import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';

import { $eventBus } from '@/eventBus';

import Navbar from './navbar/Navbar.vue';
import Sidebar from './navbar/Sidebar.vue';

@Component({
  components: {
    Navbar,
    Sidebar,
  },
})
export default class Home extends Vue {

  mounted() {
    document.addEventListener('keydown', (event) => {
      if (event.keyCode === 27) {
        $eventBus.$emit('closeModals');
      }
    });
  }

}
